/** @format */

import styled from 'styled-components';
import GalleryIcon from '../../../../../assets/gallery-icon-new.svg';
import VrIcon from '../../../../../assets/play-button-new.svg';

const VRButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border: 0;
  background-color: transparent;
  img {
    width: 30px;
    height: 30px;
  }
`;

export { GalleryIcon, VRButton, VrIcon };
